'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a header for each section of a form page.
 */
var SectionHeaderComponent = function SectionHeaderComponent(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    _reactBootstrap.Col,
    { xs: 12, className: 'flex' },
    _react2.default.createElement(
      'h3',
      { className: 'section-title' },
      (0, _translate.t)(children)
    )
  );
};

SectionHeaderComponent.propTypes = {
  children: _react2.default.PropTypes.string.isRequired
};

exports.default = SectionHeaderComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/SectionHeaderComponent.jsx
// module id = 48
// module chunks = 0